import type { AlertProps } from 'antd';
import { Alert, theme } from 'antd';
import type { CSSProperties } from 'react';
import React from 'react';

type AlertStyles = Exclude<AlertProps['styles'], undefined>;
type AlertStylesObject = Exclude<
  AlertStyles,
  (info: { props: AlertProps }) => unknown
>;

function mergeInfoStyles(
  stylesProp: AlertProps['styles'],
  iconColor: string,
): AlertProps['styles'] {
  const withIconColor = (resolved?: AlertStylesObject) => ({
    ...resolved,
    icon: {
      color: iconColor,
      ...resolved?.icon,
    } satisfies CSSProperties,
  });

  if (typeof stylesProp === 'function') {
    return (info) => withIconColor(stylesProp(info) as AlertStylesObject);
  }

  return withIconColor(stylesProp as AlertStylesObject | undefined);
}

const ThemeAlert: React.FC<AlertProps> = ({
  style,
  styles: stylesProp,
  type = 'info',
  ...rest
}) => {
  const { token } = theme.useToken();

  if (type !== 'info') {
    return <Alert type={type} style={style} styles={stylesProp} {...rest} />;
  }

  return (
    <Alert
      type={type}
      style={{
        border: `1px solid ${token.colorPrimary}`,
        background: token.colorPrimaryBg,
        ...style,
      }}
      styles={mergeInfoStyles(stylesProp, token.colorPrimary)}
      {...rest}
    />
  );
};

export default ThemeAlert;
